import { useTranslations } from 'next-intl';

const useTranslation = (
  keyPrefix: string
): { t: ReturnType<typeof useTranslations<string>> } => {
  return { t: useTranslations<string>(keyPrefix) };
};
export default useTranslation;
